export default {
  SearchPlaceholder: '搜索加速IPv4/IPv6/域名',
  ClientName: '客户名称',
  AcceleratedIP: '加速IP',
  SpeedUpDomainName: '加速域名',
  WhitelistType: '白名单类型',
}